import React from "react"
import parser from "html-react-parser"
import HoverTitle from "../../../GlobalComponents/HoverTitle/HoverTitle"
import { highlightTitleHtml } from "../../../../utils/highlightTitleHtml"
import * as styles from "./EventFormat.module.css"

const EventFormat = ({ data }) => {
  const {
    eventFormatAgenda = [],
    eventFormatLeftImage,
    eventFormatTitle,
  } = data || {}

  const imageUrl =
    eventFormatLeftImage?.node?.publicUrl ||
    eventFormatLeftImage?.node?.sourceUrl

  const titleHtml = highlightTitleHtml(
    eventFormatTitle,
    "Format",
    eventFormatTitle || "Event Format",
  )

  if (!eventFormatTitle && !eventFormatAgenda.length && !imageUrl) {
    return null
  }

  return (
    <section className={styles.section}>
      <div className="container">
        <HoverTitle html={titleHtml} className={`${styles.title} h2-medium`} />

        <div className={styles.row}>
          <ul className={styles.list}>
            {eventFormatAgenda.map((item, index) => (
              <li key={index} className={styles.item}>
                <time className={`body-very-small-regular ${styles.time}`}>
                  {item?.eventFormatDate}
                </time>
                <span className={`body-medium-medium ${styles.name}`}>
                  {item?.eventFormatTitle
                    ? parser(item.eventFormatTitle)
                    : null}
                </span>
              </li>
            ))}
          </ul>

          {imageUrl && (
            <div className={styles.media}>
              <img src={imageUrl} alt="" className={styles.image} />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default EventFormat
